import type {
  FormKitFrameworkContext,
  FormKitNode,
  FormKitTypeDefinition,
} from '@formkit/core'
// import InputSwitch from 'primevue/inputswitch'

export const ToggleInput: FormKitTypeDefinition = {
  type: 'input',
  features: [
    (node: FormKitNode) => {
      node.on('created', () => {
        node.context!.handlers.update = (newInputValue: boolean) => {
          node.input(newInputValue)
          node.emit('change', newInputValue)
        }
      })
    },
  ],
  component: ({ context }: { context: FormKitFrameworkContext }) => {
    return h('input', {
      inputId: context.id,
      modelValue: context.value,
      'onUpdate:modelValue': context.handlers.update,
    })
  },
}
